import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	tagSets: [], // Array of TagSets with their children tags
	keywords: [], // Keywords (Tag$General where tagSet.name is 'Keyword')
	isLoading: false,
	isTagSetsLoaded: false,
	isKeywordsLoaded: false,
	error: null,
};

export const tagsSlice = createSlice({
	name: 'tags',
	initialState,
	reducers: {
		setTagsLoading: (state, action) => {
			state.isLoading = action.payload;
		},
		setTagSetsState: (state, action) => {
			state.tagSets = action.payload;
			state.isTagSetsLoaded = true;
			state.isLoading = false;
			state.error = null;
		},
		setKeywordsState: (state, action) => {
			state.keywords = action.payload;
			state.isKeywordsLoaded = true;
			state.isLoading = false;
			state.error = null;
		},
		addTagToTagSet: (state, action) => {
			const { tagSetId, tag } = action.payload;
			const tagSetIndex = state.tagSets.findIndex(tagSet => tagSet._id === tagSetId);
			if (tagSetIndex !== -1) {
				// Prepend the new tag to the beginning of the array
				state.tagSets[tagSetIndex].tags.unshift(tag);
			}
		},
		addKeyword: (state, action) => {
			// Prepend the new keyword to the beginning of the array
			state.keywords.unshift(action.payload);
		},
		updateTagInTagSet: (state, action) => {
			const { tagSetId, tag } = action.payload;
			const tagSetIndex = state.tagSets.findIndex(tagSet => tagSet._id === tagSetId);
			if (tagSetIndex !== -1) {
				const tagIndex = state.tagSets[tagSetIndex].tags.findIndex(t => t._id === tag._id);
				if (tagIndex !== -1) {
					state.tagSets[tagSetIndex].tags[tagIndex] = tag;
				}
			}
		},
		updateKeyword: (state, action) => {
			const index = state.keywords.findIndex(keyword => keyword._id === action.payload._id);
			if (index !== -1) {
				state.keywords[index] = action.payload;
			}
		},
		deleteTagFromTagSet: (state, action) => {
			const { tagSetId, tagId } = action.payload;
			const tagSetIndex = state.tagSets.findIndex(tagSet => tagSet._id === tagSetId);
			if (tagSetIndex !== -1) {
				state.tagSets[tagSetIndex].tags = state.tagSets[tagSetIndex].tags.filter(tag => tag._id !== tagId);
			}
		},
		deleteKeyword: (state, action) => {
			state.keywords = state.keywords.filter(keyword => keyword._id !== action.payload);
		},
		setTagsError: (state, action) => {
			state.error = action.payload;
			state.isLoading = false;
		},
		resetTagsState: () => ({
			tagSets: [],
			keywords: [],
			isLoading: false,
			isTagSetsLoaded: false,
			isKeywordsLoaded: false,
			error: null,
		}),
	}
});

// Action creators are generated for each case reducer function
export const {
	setTagsLoading,
	setTagSetsState,
	setKeywordsState,
	addTagToTagSet,
	addKeyword,
	updateTagInTagSet,
	updateKeyword,
	deleteTagFromTagSet,
	deleteKeyword,
	setTagsError,
	resetTagsState
} = tagsSlice.actions;

export const getTagsState = (state) => state.tags;

export default tagsSlice.reducer;
